import { inject, Injectable } from "@angular/core";
import { environment } from "../../environments/environment";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { IProviderOnboardingStateDto } from "../dto/parameter";

@Injectable({ providedIn: 'root' })
export class OnboardingnService {
    private BASE_URL = environment.api.url;

    private http = inject(HttpClient);

    onboardingState(): Observable<IProviderOnboardingStateDto> {
        return this.http.get<IProviderOnboardingStateDto>(`${this.BASE_URL}/onboarding/state`)
    }

    createNewOnboardingSession(): Observable<void> {
        return this.http.post<void>(`${this.BASE_URL}/onboarding/new-session`, null)
    }

    onboardingRefresh(): Observable<{ url: string }> {
        return this.http.post<{ url: string }>(`${this.BASE_URL}/onboarding/refresh`, null);
    }

    onboardingComplete(): Observable<void> {
        return this.http.patch<void>(`${this.BASE_URL}/onboarding/complete`, null);
    }

    onboardingIncomplete(): Observable<void> {
        return this.http.post<void>(`${this.BASE_URL}/onboarding/incomplete`, null);
    }
}